import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, Modal } from "@mui/material";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Search } from "@mui/icons-material";
// eslint-disable-next-line react/prop-types
function ConsultaGestion({ id, descripcion }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const formatFechaColombia = (fecha) => {
    if (!fecha) return "Fecha no disponible";
    const date = new Date(fecha);
    return date.toLocaleString("es-CO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "America/Bogota",
    });
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "1500px",
    height: "70vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    overflowY: "auto",
    fontSize: "12px",
  };

  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Fecha Creación", accessor: "fechaCreacion" },
    { Header: "Nombre", accessor: "nombre" },
    { Header: "Descripción", accessor: "descripcion" },
  ];

  const fetchData = async () => {
    if (!id) return;
    try {
      const response = await axios.get(
        `https://contratosback.azurewebsites.net/api/v1/ObtenerGestiones/${id}`
      );

      const data = response.data.map((item) => ({
        id: item.id,
        idSolicitud: item.idSolicitud,
        fechaCreacion: formatFechaColombia(item.fechaCreacion),
        nombre: item.nombre || "N/A",
        descripcion: item.descripcion || "Sin descripción",
      }));

      setRows(data);
    } catch (error) {
      console.error("Error al obtener gestiones:", error);
    }
  };

  // Fetch al abrir el modal y luego cada 5 segundos si está abierto
  useEffect(() => {
    let intervalId;

    if (open) {
      fetchData(); // Llamado inmediato
      intervalId = setInterval(fetchData, 5000); // Cada 5 segundos
    }

    return () => {
      if (intervalId) clearInterval(intervalId); // Limpiar al cerrar
    };
  }, [open, id]);

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-crear-caso">Ver Gestiones</Tooltip>}
      >
        <Button variant="contained" color="primary" onClick={handleOpen}>
          <Search style={{ color: "white", fontSize: "1.2rem" }} />
        </Button>
      </OverlayTrigger>

      <Modal open={open} onClose={handleClose} aria-labelledby="modal-title">
        <Box sx={modalStyle}>
          <Box sx={{ border: "2px solid #ccc", borderRadius: "8px", overflow: "hidden" }}>
            <p>
              <strong>Información Principal:</strong> {descripcion}
            </p>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col.accessor}
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        background: "#f4f4f4",
                        fontSize: "12px",
                      }}
                    >
                      {col.Header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    {columns.map((col) => (
                      <td
                        key={col.accessor}
                        style={{ border: "1px solid #ccc", padding: "8px", fontSize: "12px" }}
                      >
                        {col.accessor === "descripcion" ? (
                          <div dangerouslySetInnerHTML={{ __html: row[col.accessor] }} />
                        ) : (
                          row[col.accessor]
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button onClick={handleClose} variant="contained" color="light">
              <span style={{ color: "blue" }}>Cerrar</span>
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default ConsultaGestion;
